import { AUTOCOMPLETE_CONFIG } from '@/constants/autocomplete'

export const shouldFetchAutocompleteForQuery = (
	query: string | undefined
): boolean =>
	(query ?? '').trim().length >= AUTOCOMPLETE_CONFIG.MIN_FETCH_QUERY_LENGTH
